import React, { useMemo, useState } from "react";
import { Input, InputProps } from "antd";

interface StyledPasswordInputProps extends InputProps {}

const StyledPasswordInput: React.FC<StyledPasswordInputProps> = ({
  className,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const isControlled = value !== undefined;
  const [uncontrolledValue, setUncontrolledValue] = useState<string>(
    defaultValue?.toString() ?? ""
  );

  const currentValue = isControlled ? value : uncontrolledValue;
  const hasValue = useMemo(() => {
    if (currentValue === undefined || currentValue === null) {return false;}
    if (Array.isArray(currentValue)) {return currentValue.length > 0;}
    return String(currentValue).length > 0;
  }, [currentValue]);

  return (
    <Input.Password
      {...props}
      value={isControlled ? value : uncontrolledValue}
      onChange={event => {
        if (!isControlled) {
          setUncontrolledValue(event.target.value);
        }
        onChange?.(event);
      }}
      className={`styled-text-input ${hasValue ? "styled-text-input--has-value" : ""} ${
        className || ""
      }`}
    />
  );
};

export default StyledPasswordInput;
